export const USER_ROLES = {
  INVESTOR: 'investor',
  MANAGER: 'manager',
  PROPERTY_MANAGER: 'property_manager',
  ACCOUNTANT: 'accountant',
  ATTORNEY: 'attorney',
  DIRECTOR: 'director',
  FRONT_DESK: 'front_desk',
} as const;

export type UserRole = typeof USER_ROLES[keyof typeof USER_ROLES];

export const ROLE_ARRAY = Object.values(USER_ROLES);

/** A demo visitor's refused change: the API answers 403 with this code and sentence, and the web shows the sentence. */
export const DEMO_VIEW_ONLY = { code: 'demo_view_only', message: 'This is a demo, so changes are turned off.' } as const;
